export enum SceneEvents{
  MobSpawned='mobSpawned',
  Score='scored',
  Leak='leaked',
  ScoreCleared='scoreCleared',
  WaveFinished='waveFinish',
  WaveStarted='waveStart'
}
export enum GameEvents{
  sceneReady='sceneReady',
}